import React from 'react'
import { graphql } from 'gatsby'
import { Layout, FAQSection, Testimonial } from '../components/common'
import {
  OverviewSection,
  MainImage,
  FeaturesSet
} from '../components/CoachResources'
import testimonials from '../seedData/testimonials'

const OurCoachesPage = ({ data = {} }) => {
  return (
    <Layout query={data} title='PGA.Coach'>
      <MainImage />
      <OverviewSection />
      <FeaturesSet />
      <Testimonial
        author={testimonials.wilson.author}
        blockquote={testimonials.wilson.blockquote}
        avatar={data.author3.childImageSharp.fixed}
      />
      <FAQSection />
    </Layout>
  )
}
export const query = graphql`
  query imageQuery2 {
    author3: file(relativePath: { eq: "Home/author3.png" }) {
      ...optimizedSharpSizes96
    }
  }
`
export default OurCoachesPage
